// Integración con QZ Tray: el puente local (app gratis instalada en la PC de packing)
// que permite mandar ZPL crudo a una impresora térmica desde el navegador.
//
// Modo SIN certificado (Fase A): QZ pide una confirmación la primera vez; con
// "Recordar esta decisión" queda silencioso para siempre en esa PC. El certificado
// firmado para 0 prompts queda para Fase B.
import qz from "qz-tray";

let securityConfigured = false;
const configureSecurity = () => {
  if (securityConfigured) return;
  // Sin certificado → QZ opera en modo "no confiable" (muestra el prompt de permiso).
  qz.security.setCertificatePromise((resolve) => resolve());
  qz.security.setSignatureAlgorithm("SHA512");
  qz.security.setSignaturePromise(() => (resolve) => resolve());
  securityConfigured = true;
};

let connectPromise = null;

// Conecta con QZ Tray en localhost. Idempotente: reusa la conexión activa.
export const connectQz = async () => {
  configureSecurity();
  if (qz.websocket.isActive()) return;
  if (!connectPromise) {
    connectPromise = qz.websocket
      .connect({ retries: 2, delay: 1 })
      .catch((err) => {
        connectPromise = null;
        throw err;
      });
  }
  return connectPromise;
};

export const isQzConnected = () => {
  try {
    return qz.websocket.isActive();
  } catch {
    return false;
  }
};

// Lista las impresoras que QZ ve en esta PC (para el selector del perfil).
export const listPrinters = async () => {
  await connectQz();
  const found = await qz.printers.find();
  return (Array.isArray(found) ? found : [found]).filter(Boolean);
};

// Manda ZPL crudo a la impresora indicada.
export const printZpl = async (printerName, zpl) => {
  if (!printerName) throw new Error("No hay impresora configurada en esta PC.");
  await connectQz();
  const cfg = qz.configs.create(printerName, { encoding: "UTF-8" });
  await qz.print(cfg, [{ type: "raw", format: "command", flavor: "plain", data: zpl }]);
};

// ── Configuración de impresora POR PC (localStorage) ──
// La impresora es física de cada estación, así que su nombre/tamaño/DPI viven en la PC,
// no en la cuenta. La política "auto-imprimir sí/no" sí es de la empresa (va en la DB).
const KEY = "ficanaz_printer_config";

const DEFAULTS = { dpi: 203, labelSize: "10x15", language: "tspl", printerName: "" };

export const getPrinterConfig = () => {
  let cfg;
  try {
    cfg = { ...DEFAULTS, ...(JSON.parse(localStorage.getItem(KEY)) || {}) };
  } catch {
    cfg = { ...DEFAULTS };
  }
  // labelFormat: "direct" (ZPL/TSPL vía QZ Tray) | "pdf" (descarga). Default
  // retrocompatible: una PC con impresora ya configurada sigue imprimiendo directo;
  // una PC sin configurar descarga PDF (la etiqueta siempre tiene que salir).
  if (cfg.labelFormat !== "direct" && cfg.labelFormat !== "pdf") {
    cfg.labelFormat = cfg.printerName ? "direct" : "pdf";
  }
  return cfg;
};

export const savePrinterConfig = (cfg) => {
  const merged = { ...getPrinterConfig(), ...cfg };
  localStorage.setItem(KEY, JSON.stringify(merged));
  return merged;
};
